import { useMemo } from 'react';

// Celebratory confetti burst used on payment / claim success. Self-contained:
// drop `<Confetti />` into a screen while a success state is showing. Pointer
// events are disabled and it's constrained to the app's phone-width column so
// it rains inside the frame on desktop rather than across the whole monitor.
const COLORS = ['#00d632', '#00D632', '#E1F9E7', '#FFFFFF', '#00D632', '#E1F9E7'];

export default function Confetti({ count = 28 }: { count?: number }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        i,
        left: Math.random() * 100,
        delay: Math.random() * 0.25,
        dur: 0.9 + Math.random() * 0.8,
        dx: (Math.random() - 0.5) * 140,
        size: 6 + Math.random() * 6,
        color: COLORS[i % COLORS.length],
        round: Math.random() > 0.5,
      })),
    [count],
  );

  return (
    <div
      aria-hidden
      style={{
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: 480,
        pointerEvents: 'none',
        overflow: 'hidden',
        zIndex: 9999,
      }}
    >
      {pieces.map(p => (
        <span
          key={p.i}
          style={{
            position: 'absolute',
            top: -16,
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 1.4,
            backgroundColor: p.color,
            borderRadius: p.round ? '50%' : 2,
            animation: `sls-confetti-fall ${p.dur}s ${p.delay}s cubic-bezier(0.2,0.6,0.3,1) forwards`,
            ...({ '--dx': `${p.dx}px` } as any),
          }}
        />
      ))}
    </div>
  );
}
